import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { CommonUtil } from '../../../../core/Utils/common-util';
import { HaloLoaderService } from '../../../../core/halo-loader/halo-loader.service';
import { EquipmentService } from '../../../services/equipment.service';

@Component({
  selector: 'app-product-page-modal',
  templateUrl: './product-page-modal.component.html',
  styleUrls: ['./product-page-modal.component.scss']
})
export class ProductPageModalComponent implements OnInit {

  rootScopeData: RootScopeDeclare;
  cloudBasePath: string;
  @Input() product_url: number;
  @Output() callOnBtnClick: EventEmitter<string> = new EventEmitter();

  constructor(private rootScopeService: RootScopeService, private commonUtil: CommonUtil,
    private _loader: HaloLoaderService, private _equipmentService: EquipmentService) { }

  
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  ngOnInit(): void {
    this.getRootScopeData();
  }


  onNegativeButtonClick(): void {
    this.callOnBtnClick.emit();
  }


  stopBubbling(e: Event) {
    e.stopPropagation();
  }

}

